import React from 'react'
import PropTypes from 'prop-types'

const HorizontalRow = ({ onToggleSpecification, isToggled }) => {
  return (
    <div className="row mt-5">
      <div className="text-center hr-div" style={{ cursor: 'pointer' }} onClick={() => onToggleSpecification(!isToggled)}>
        <div className="hr-text">Specifikation</div>
        <div className="hr-arrow"></div>
      </div>
    </div>
  )
}

HorizontalRow.propTypes = {
  onToggleSpecification: PropTypes.func.isRequired,
  isToggled: PropTypes.bool.isRequired
}

export default HorizontalRow
